export default __webpack_public_path__ + "static/hypershift_screen_1-96bc2125eff127a77351827d25ee5fac.svg";